import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import _ from 'underscore'
import cookie from '../lib/cookie'
import CARD_CONSTANT from '../constant/card'
const getCardDetail = (data) => {
    return new Promise((resolve, reject) => {

        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.user.card.detail',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                //卡过期状态码为6801116
                if (data.status !== 0 && data.status !== 6801116) {
                    return reject(data)
                }
                // if (data.status !== 0) {
                //     return reject(data)
                // }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const getCardDetailOnly = (data) => {
    return new Promise((resolve, reject) => {

        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.user.card.detail-unique-code',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0 && data.status !== 6801116) {
                    return reject(data)
                }
                // if (data.status !== 0) {
                //     return reject(data)
                // }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const cardBinding = (data) => {
    return new Promise((resolve, reject) => {

        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.user.card.binding',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status == 6811002) {
                    return reject(CARD_CONSTANT.CARD_CARDBINDING_NOTICE)
                } else if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const cardRenew = (data) => {
    return new Promise((resolve, reject) => {

        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.asset.card.delay-check',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const cardRenewV2 = (data) => {
    return new Promise( (resolve, reject)=> {

        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.asset.card.delay-check.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getCardToken = (data) => {
    return new Promise((resolve, reject) => {

        let query = ''
        if (!_.isEmpty(data)) {
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url, {
            headers: {
                'X-Host': 'mall.user.card.token',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const removeCardBinding = (data) => {
    return new Promise((resolve, reject) => {

        /*         let query = ''
                if(!_.isEmpty(data)){
                    query = `?${qs.stringify(data)}`
                }
                let url = `${CONSTANT.REQUEST_HOST}${query}` */
        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.user.card.remove-binding',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const getCardPassword = (data) => {
    return new Promise((resolve, reject) => {

        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.user.card.password',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const getUsefulCards = (data) => {
    return new Promise((resolve, reject) => {
        data.validFlag = 1
        let query = ''
        if (!_.isEmpty(data)) {
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url, {
            headers: {
                'X-Host': 'mall.user.card.list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status == 6003) {
                    return resolve([])
                }
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const getUselessCards = (data) => {
    return new Promise((resolve, reject) => {
        data.validFlag = 0
        let query = ''
        if (!_.isEmpty(data)) {
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url, {
            headers: {
                'X-Host': 'mall.user.card.list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status == 6003) {
                    return resolve([])
                }
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const getLimitCity = (data) => {
    return new Promise((resolve, reject) => {
        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.card.limit.city',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const getLimitCinema = (data) => {
    return new Promise((resolve, reject) => {
        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)
        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.card.city.limit.cinema',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const getCardBanner = (data) => {
    return new Promise((resolve, reject) => {
        data = { type: CARD_CONSTANT.BANNER_TYPE }
        let query = ''
        if (!_.isEmpty(data)) {
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url, {
            headers: {
                'X-Host': 'mall.cfg.common-banner',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}

const getCardConsume = (data) => {
    return new Promise((resolve, reject) => {

        let query = ''
        if (!_.isEmpty(data)) {
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url, {
            headers: {
                'X-Host': 'mall.user.card.consume-record.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const getCardBillList = (data) => {
    return new Promise((resolve, reject) => {

        let query = ''
        if (!_.isEmpty(data)) {
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url, {
            headers: {
                'X-Host': 'mall.user.card.bill-list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}
const updateCodeStatus = (data) => {
    return new Promise((resolve, reject) => {

      let url = CONSTANT.REQUEST_HOST
      data = JSON.stringify(data)

        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.order.update-code-status',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}

// 获取影院详情
const getCinemaInfo = (id) => {
    return new Promise((resolve, reject) => {
        let url = `${CONSTANT.REQUEST_HOST}`
        return Api.get(`${url}/?cinemaId=${id}`, {
            headers: {
                'X-Host': 'mall.film-ticket.cinema.info',
            }
        }).then((data) => {
            if (data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, (e) => {
            reject(e)
        })
    })
}

const cardChangePassNotify = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.user.card.changePassNotify',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}

// 进店使用-选择品牌页面请求所有品牌列表
const getPinPaiList = (data) => {
    return new Promise((resolve, reject) => {

      let url = CONSTANT.REQUEST_HOST
      data = JSON.stringify(data)

        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.card.city-brand-list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status == 6003) {
                    return resolve([])
                }
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}

// 进店使用-获取消费账单详情
const getBillListShop = (data) => {
    return new Promise((resolve, reject) => {

      let url = CONSTANT.REQUEST_HOST
      data = JSON.stringify(data)

        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.user.card.bill-record',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}

// 进店使用-获取二维码
const getPaymentCode = (data) => {
    return new Promise((resolve, reject) => {

      let url = CONSTANT.REQUEST_HOST
      data = JSON.stringify(data)

        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.user.card.get-payment-code',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}

// 进店使用-获取最近门店
const getRecentShop = (data) => {
    return new Promise((resolve, reject) => {

      let url = CONSTANT.REQUEST_HOST
      data = JSON.stringify(data)

        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.card.nearest-store',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}

// 进店使用-获取消费记录数据
const getrecordsPay = (data) => {
    return new Promise((resolve, reject) => {

      let url = CONSTANT.REQUEST_HOST
      data = JSON.stringify(data)

        Api.post(url, data, {
            headers: {
                'X-Host': 'mall.asset.card.payment-code-consume-record',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
            .then((data) => {
                if (data.status !== 0) {
                    return reject(data.msg)
                }
                resolve(data.data)
            },
                (e) => {
                    reject(e)
                })
    })
}

// 获取用户卡列表
const getUserCardList = () => {
    return new Promise((resolve, reject) => {
        const url = CONSTANT.REQUEST_HOST
        Api.get(url, {
            headers: {
                'X-Host': 'mall.user.card.simple-list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((res) => {
            if (res.status !== 0) {
                return reject(res.msg)
            }
            resolve(res.data);
        },
        (e) => {
            reject(e);
        })
    })
}

// 获取用户卡账单
const getNewCardBillList = (data) => {
    return new Promise((resolve, reject) => {
        let query = ''
        if (!_.isEmpty(data)) {
            query = `?${qs.stringify(data)}`
        }
        const url = `${CONSTANT.REQUEST_HOST}${query}`
        Api.get(url, {
            headers: {
                'X-Host': 'mall.user.card.bill-list-v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((res) => {
            if (res.status !== 0) {
                return reject(res.msg)
            }
            resolve(res.data);
        },
        (e) => {
            reject(e);
        })
    })
}

/*yeoman-template-point-1*/
export default {
    getCardDetail,
    getCardDetailOnly,
    cardBinding,
    cardRenew,
    cardRenewV2,
    getCardToken,
    removeCardBinding,
    getCardPassword,
    getUsefulCards,
    getUselessCards,
    getCardBanner,
    getLimitCity,
    getLimitCinema,
    getCardBanner,
    getCardConsume,
    getCardBillList,
    getCinemaInfo,
    cardChangePassNotify,
    getPinPaiList,
    getBillListShop,
    getPaymentCode,
    getRecentShop,
    getrecordsPay,
    getUserCardList,
    getNewCardBillList,
/*yeoman-template-point-2*/
}
